import React from "react";
import {
	Box,
	Grid,
	Button,
	Typography,

	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {
	VisibleContent
} from "../../../../../components";

class DialogExamplesImagesFromSite extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			type: "",
			product: null,
			isOpen: false,
			isCollection: false,
		};
	}

	open = ({product, type}) => {
		console.log('product: ', product);
		this.setState({
			type,
			product,
			isOpen: true,
			isCollection: product.isProductSet,
		})
	};
	close = () => {
		this.setState({
			type: '',
			product: '',
			isOpen: false,
		})
	}

	render () {
		const {
			product,
			isOpen,
			isCollection
		} = this.state;

		if (!isOpen) {
			return null
		}
		return (
			<Dialog
				open={isOpen}
				maxWidth="md"
				fullWidth
			>
				<DialogTitle>
					<Typography variant="h3">Пример фото на сайте</Typography>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<VisibleContent visible={isCollection}>
								<CollectionPageMain imageId={product.imageId}/>
							</VisibleContent>
							<VisibleContent visible={!isCollection}>
								<ProductPageMain imageId={product.imageId}/>
							</VisibleContent>
						</Grid>
						<VisibleContent visible={!isCollection}>
							<Grid item xs={4.5}>
								<ProductFromPageCollection imageId={product.imageId}/>
							</Grid>
							<Grid item xs={4.5}>
								<ProductFromCatalog imageId={product.imageId}/>
							</Grid>
							<Grid item xs={3}>
								<OtherProductCollection imageId={product.imageId}/>
							</Grid>
						</VisibleContent>
						<VisibleContent visible={isCollection}>
							<Grid item xs={6}>
								<CollectionFromCatalog imageId={product.imageId}/>
							</Grid>
						</VisibleContent>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Box sx={{display: "flex", justifyContent: "flex-end"}} px={2}>
						<Button
							variant="contained"
							onClick={this.close}
						>Закрыть</Button>
					</Box>
				</DialogActions>
			</Dialog>
		)
	}
}
const ProductPageMain = ({imageId}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.sectionTitle}>Страница товара, фото в главном слайдере</div>
			<div className={classes.productPageMain}>
				<img src={`${ process.env.REACT_APP_HOST_API }/api/storage/image/${ imageId }_border-default_w-1148_h-806_fit-default.webp`}/>
			</div>
		</>
	)
};
const ProductFromCatalog = ({imageId}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.sectionTitle}>Карточка товара в каталоге<br/>&nbsp;</div>
			<div className={classes.productFromCatalog}>
				<img src={`${ process.env.REACT_APP_HOST_API }/api/storage/image/${ imageId }_border-default_w-414_h-319_fit-default.webp`}/>
			</div>
		</>
	)
};
const CollectionPageMain = ({imageId}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.sectionTitle}>Страница коллекции, фото в главном слайдере</div>
			<div className={classes.collectionPageMain}>
				<img src={`${ process.env.REACT_APP_HOST_API }/api/storage/image/${ imageId }_border-default_w-1079_h-758_fit-default.webp`}/>
			</div>
		</>
	)
};
const CollectionFromCatalog = ({imageId}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.sectionTitle}>Карточка коллекции в каталоге</div>
			<div className={classes.сollectionFromCatalog}>
				<img src={`${ process.env.REACT_APP_HOST_API }/api/storage/image/${ imageId }_border-default_w-565_h-397_fit-default.webp`}/>
			</div>
		</>
	)
};
const OtherProductCollection = ({imageId}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.sectionTitle}>Другие товары этой коллекции</div>
			<div className={classes.otherProductCollection}>
				<img src={`${ process.env.REACT_APP_HOST_API }/api/storage/image/${ imageId }_border-default_w-178_h-137_fit-default.webp`}/>
			</div>
		</>
	)
};
const ProductFromPageCollection = ({imageId}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.sectionTitle}>Карточка товара на странице коллекции</div>
			<div className={classes.productFromPageCollection}>
				<img src={`${ process.env.REACT_APP_HOST_API }/api/storage/image/${ imageId }_border-default_w-420_h-420_fit-default.webp`}/>
			</div>
		</>
	)
};

const useStyles = makeStyles(() => ({
	sectionTitle: {
		marginBottom: 8,
		fontSize: 18,
		lineHeight: 1.2,
		color: "black",
		fontWeight: "600",
	},

	productPageMain: {
		display: "flex",
		width: "100%",
		position: "relative",
		borderRadius: 20,
		overflow: "hidden",
		border: "1px solid rgba(0,0,0,0.1)",
		"& img": {
			position: "absolute",
			top: 0, left: 0,
			width: "100%",
      height: "100%",
      objectFit: "contain"
		},
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "70.216%"
		}
	},
	collectionPageMain: {
		display: "flex",
		width: "100%",
		position: "relative",
		borderRadius: 20,
		overflow: "hidden",
		border: "1px solid rgba(0,0,0,0.1)",
		"& img": {
			position: "absolute",
			top: 0, left: 0,
			width: "100%",
			height: "100%",
			objectFit: "contain"
		},
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "70.216%"
		}
	},
	productFromCatalog: {
		display: "flex",
		width: "100%",
		position: "relative",
		borderRadius: 20,
		overflow: "hidden",
		border: "1px solid rgba(0,0,0,0.1)",
		"& img": {
			position: "absolute",
			top: 0, left: 0,
			width: "100%",
			height: "100%",
			objectFit: "contain"
		},
		"&:after": {
			content: "''",
			float: "left",
			padding: "38.53%"
		}
	},
	сollectionFromCatalog: {
		display: "flex",
		width: "100%",
		position: "relative",
		borderRadius: 20,
		overflow: "hidden",
		border: "1px solid rgba(0,0,0,0.1)",
		"& img": {
			position: "absolute",
			top: 0, left: 0,
			width: "100%",
			height: "100%",
			objectFit: "contain"
		},
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "70.153%"
		}
	},
	otherProductCollection: {
		display: "flex",
		width: "100%",
		position: "relative",
		borderRadius: 20,
		overflow: "hidden",
		border: "1px solid rgba(0,0,0,0.1)",
		"& img": {
			position: "absolute",
			top: 0, left: 0,
			width: "100%",
			height: "100%",
			objectFit: "contain"
		},
		"&:after": {
			content: "''",
			float: "left",
			padding: "38.53%"
		}
	},
	productFromPageCollection: {
		display: "flex",
		width: "100%",
		position: "relative",
		borderRadius: 20,
		overflow: "hidden",
		border: "1px solid rgba(0,0,0,0.1)",
		"& img": {
			position: "absolute",
			top: 0, left: 0,
			width: "100%",
			height: "100%",
			objectFit: "contain"
		},
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "100%"
		}
	},
}))

export default DialogExamplesImagesFromSite
